// users

export const AUTH = "AUTH";
export const REQ_AUTH = "REQ_AUTH";
export const AUTH_ERROR = "AUTH_ERROR";

// posts

export const FETCH_POSTS = "FETCH_POSTS";
export const NEW_POST = "NEW_POST";
export const DELETE_POST = "DELETE_POST";
export const LIKE_POST = "LIKE_POST";
export const UPDATE_POST = "UPDATE_POST";
export const NEW_COMMENT = "NEW_COMMENT";
export const DEL_COMMENT = "DEL_COMMENT";

// chats

export const FETCH_ROOMS = "FETCH_ROOMS";

// searches

export const SEARCH = "SEARCH";